export const MODAL_BACKDROP_CENTER_CLASS =
  'fixed inset-0 z-[60] flex items-center justify-center overflow-y-auto overscroll-y-contain p-4';

export const MODAL_BACKDROP_BOTTOM_CLASS = MODAL_BACKDROP_CENTER_CLASS;

/** Standard modal scrim (style guide §4.3 / §2.3.7). */
export const MODAL_BACKDROP_SCRIM_CLASS = 'bg-black/40 dark:bg-black/55';

/** Standard light/dark modal panel shell. */
export const MODAL_PANEL_SURFACE_CLASS =
  'w-full max-w-md rounded-xl border border-gray-200 bg-white p-5 shadow-lg dark:border-gray-700 dark:bg-gray-900';

export const MODAL_PANEL_SCROLL_DVH_CLASS =
  'max-h-[calc(100dvh-2rem)] overflow-y-auto overscroll-y-contain [touch-action:pan-y]';
